import { Injectable } from '@angular/core';
import { ApiClientService } from './api.client.service';

import { LookupDto } from '../../model/lookupDto';
import { FunctionsService } from '../../services/functions.service';

@Injectable()
export class LookupService {
    constructor(private http: ApiClientService, private functionsService: FunctionsService) { }

    getSections() {
        return this.http.get('/secure/lookup/section', { secure: false });
    }
    getRegions() {
        return this.http.get('/secure/lookup/region', { secure: false });
    }
    getCategories() {
        return this.http.get('/secure/lookup/category', { secure: false });
    }
    getDenominations() {
        return this.http.get('/secure/lookup/denomination', { secure: false });
    }
    getPriority() {
        return this.http.get('/secure/lookup/priority', { secure: false });
    }
    getLookup(id: number) {
        return this.http.get('/secure/lookup/' + id, { secure: false });
    }
    // getLevels() {
    //     return this.http.get('/level');
    // }
    getLevelsByEducationalCenterId(educationalCenterId: number) {
        return this.http.get('/secure/educationalCenter/' + educationalCenterId + '/level', { secure: false });
    }
    getEducationalLevels() {
        return this.http.get('/secure/lookup/educationalLevel', { secure: false });
    }
    getSubLevels() {
        const isEpda = this.functionsService.isEpda();
        const curricularSpaceParam = isEpda !== null ? '?isEpda=' + isEpda : '';

        return this.http.get('/subLevel' + curricularSpaceParam);
    }
    getCountries() {
        return this.http.get('/secure/country', { secure: false });
    }
    getCitySL() {
        return this.http.get('/secure/citySL', { secure: false });
    }
    getCity(countryId: number) {
        return this.http.get('/secure/city/country/' + countryId, { secure: false });
    }
    getSchoolShift() {
        return this.http.get('/lookup/schoolShift');
    }
    // handleApiFeedback activa error/spinner centralizados en ApiClientService.
    getSchoolShiftFilterOperator(handleApiFeedback: boolean = false) {
        return this.http.apiGet<LookupDto[]>('/lookup/schoolShift/filterOperator', {
            showSpinner: handleApiFeedback,
            handleError: handleApiFeedback
        });
    }
    getSchoolShiftFilterOperatorAndLevel() {
        return this.http.get('/lookup/schoolShift/filter');
    }
    getWorkShift() {
        return this.http.get('/secure/lookup/workShift', { secure: false });
    }
    getDeletionReasons() {
        return this.http.get('/secure/lookup/delete/registration/reason', { secure: false });
    }
    getDeletionFactors() {
        return this.http.get('/secure/lookup/delete/registration/factor', { secure: false });
    }
    getDocumentPersonType() {
        return this.http.get('/secure/documentPersonType', { secure: false });
    }
    getDocumentPersonTypeByCode(code: string) {
        return this.http.get('/secure/documentPersonType/code/' + code, { secure: false });
    }
    getQuestions(studentId: any) {
        return this.http.get('/secure/lookup/questions/student/' + studentId, { secure: false });
    }
    getSchoolCycle() {
        return this.http.get('/schoolCycle');
    }
    getSchoolYear() {
        return this.http.get('/schoolYear/activeAndClose');
    }
    schoolyearsWithPof() {
        return this.http.get('/schoolCycle/withPof');
    }
    getSchoolCycleCurrent() {
        return this.http.get('/schoolCycle/currentAndFutures');
    }
    getFamilyComposition() {
        return this.http.get('/secure/lookup/familyComposition', { secure: false });
    }
    getCurricularSpace(levelId: any) {
        return this.http.get('/curricularSpace');
    }
    getStudentGroup(curricularSpaceId: number, subLevelId: any, schoolShiftId: any) {
        return this.http.get('/studentGroup/curricularSpace/' + curricularSpaceId + '/subLevel/' + subLevelId + '/schoolShift/' + schoolShiftId);
    }
    getStudentGroupWhitSchoolCycleCurrent(curricularSpaceId: number, subLevelId: any, schoolShiftId: any, schoolCycleId: any) {
        return this.http.get('/studentGroup/curricularSpace/' + curricularSpaceId + '/subLevel/' + subLevelId + '/schoolShift/' + schoolShiftId + '/schoolCycle/' + schoolCycleId);
    }
    // handleApiFeedback activa error/spinner centralizados en ApiClientService.
    getStudentGroupForSchoolCycleCurrent(curricularSpaceId: number, subLevelId: number, schoolShiftId: number, handleApiFeedback: boolean = false) {
        return this.http.apiGet<LookupDto[]>(`/studentGroup/curricularSpace/${curricularSpaceId}/subLevel/${subLevelId}/schoolShift/${schoolShiftId}/current`, {
            showSpinner: handleApiFeedback,
            handleError: handleApiFeedback
        });
    }
    getGradesByCurricularSpace(levelId: any, curricularSpaceId: any) {
        return this.http.get('/subLevel/curricularSpace/' + curricularSpaceId);
    }

    getSchoolTransferReason() {
        return this.http.get('/secure/lookup/schoolTransferReason', { secure: false })
    }

    public getEducationalCenterId() {
        const educationalCenterId: number = JSON.parse(localStorage.getItem('educationalCenters')) ? JSON.parse(localStorage.getItem('educationalCenters')).id : '';
        return educationalCenterId;
    }
    getReasons() {
        return this.http.get('/secure/lookup/reasons', { secure: false });
    }
    getReasonTeacherAbsenceJustification() {
        return this.http.get('/secure/lookup/reasonTeacherAbsenceJustification', { secure: false });
    }
    getReasonStudentAbsenceJustification() {
        return this.http.get('/secure/lookup/reasonStudentAbsenceJustification', { secure: false });
    }
    getAverageType() {
        return this.http.get('/secure/lookup/averageType', { secure: false });
    }
    getReasonEvaluations(): any {
        return this.http.get('/secure/lookup/test/reasons', { secure: false });
    }
    getReasonSpecialEvaluations(): any {
        return this.http.get('/secure/lookup/specialTest/reasons', { secure: false });
    }

    //License
    getLicenseType() {
        return this.http.get(`/secure/admin/lookup/licenseType`, { secure: false });
    }
    getLicenseReason() {
        return this.http.get(`/secure/admin/lookup/licenseReason`, { secure: false });
    }
    getDisabilityType() {
        return this.http.get('/secure/admin/lookup/disability', { secure: false });
    }
    getDisabilityTypeById(id:any) {
        return this.http.get('/secure/admin/lookup/'+id, { secure: false });
    }
    getSchoolCyclePast(){
        return this.http.get('/schoolCycle/pastCloseAndActive');
    }

    getLaw26206() {
        return this.http.get('/secure/admin/lookup/law26206', { secure: false })
    }

    getForIncidentCurricularSpaceByLevelId(curricularSpaceId: any, subLevelId: any, workShiftId: any) {
        const curricularSpace = curricularSpaceId !== null ? 'curricularSpaceId=' + curricularSpaceId : '';
        const subLevel = subLevelId !== null ? '&subLevelId=' + subLevelId : '';
        const workShift = workShiftId !== null ? '&schoolShiftId=' + workShiftId : '';
        return this.http.get('/studentGroup/current?' + curricularSpace + subLevel + workShift, { })
    }

    getDocumentPersonTypeBySchoolCycleIdAndPersonId(schoolCycleId: any, personId: any) {
        return this.http.get(`/secure/documentPersonType/schoolCycle/${schoolCycleId}/person/${personId}`, { secure: false });
    }

    getIncidenceType() {
        return this.http.get('/lookup/incidentType')
    }

    getLookupsByTypeCode(typeCode: string) {
        return this.http.apiGet<LookupDto[]>(`/secure/lookup/type/${typeCode}`, { secure: false });
    }
}



// WEBPACK FOOTER //
// D:/Projects/GitHub/education-ee-web/src/app/services/util/lookup.service.ts